import React, { Component } from 'react';
import {
    TextInput,
    Create,
    SimpleForm,
    SelectInput,
    ReferenceInput,
    // LongTextInput,
    BooleanInput,
    // DisabledInput,
} from 'react-admin';

// const required = (message = 'Required') =>
//     value => value ? undefined : message;

class HEXSelectorUserCreate extends Component {
    render() {
        return (
            <Create {...this.props}>
                <SimpleForm redirect="/users">
                    <ReferenceInput label="License status" source="licenseStatus" reference="HEXSelector/LicenseStatuses">
                        <SelectInput optionText="name" />
                    </ReferenceInput>
                    <ReferenceInput label="User status" source="userStatus" reference="HEXSelector/UserStatuses">
                        <SelectInput optionText="name" />
                    </ReferenceInput>
                    <TextInput source="contactPerson" label="Contact person" />
                    <TextInput source="supplier" label="Supplier" />
                    <ReferenceInput label="License" source="segmentsId" reference="HEXSelector/Segments">
                        <SelectInput optionText="name" />
                    </ReferenceInput>
                    <img alt='' src="HEXSelectorCalculationPermissions.jpg" style={{width:"100%",maxWidth:1000}} />
                    <BooleanInput source="enablePandoraEditor" label="Full Pandora Editor" />
                    <BooleanInput source="enableGeneralPandoraEditor" label="General Pandora Editor" />
                    <BooleanInput source="enableFluidEditor" label="Fluid Editor" />
                    <BooleanInput source="enableGlobalPriceList" label="Global Price List" />
                </SimpleForm>
            </Create>
        );
    }
}

export default HEXSelectorUserCreate;